import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("添 加")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("账单")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("房租物管分摊")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("审批")
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 合同详情 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 上传合同 ")
const _hoisted_9 = { class: "el-dropdown-link" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("操作")
const _hoisted_11 = { class: "pl-10 pr-10" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1)
const _hoisted_13 = { class: "mb-10" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 编 辑 ")
const _hoisted_15 = { class: "mb-10" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 申请人维护 ")
const _hoisted_17 = { class: "mb-10" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 明 细 ")
const _hoisted_19 = { class: "mb-10" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 删 除 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("请选择文件一起上传")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("选择租赁合同")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("上传合同")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("作废")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 下 载 ")

import eptBtn from '@/components/ExportButton.vue'
import {  ref, Ref, reactive, toRaw, computed, onBeforeMount, watch } from 'vue'

import dayjs from "dayjs"
import tbMix, { userCfig, cpyCfig } from '@/global_mixin/tableMixin'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import { ElMessage, ElMessageBox } from 'element-plus'
import { getNumber, formatNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/house_leases/list': fetchList,
  // 员工列表(不分页,下拉框)
  'GET/users/list': userListApi,
  // 创建
  'POST/house_leases': createdLeaseApi,
  // 删除租赁
  'DELETE/house_leases/{id}': delLeaseApi,
  // 编辑
  'PATCH/house_leases': editLeaseApi,
  // 上传租赁合同
  'POST/house_lease_contracts/upload': upContractApi,
  // 根据合同编号获取租赁合同文件列表
  'GET/house_lease_contracts': getLease_contractApi,
  // 下载租赁合同
  'GET/house_lease_contracts/download': downContractApi,
  // 获取文件凭证
  'GET/lease_payment_logs': getPaymentsApi,
  // 下载支付凭证
  'GET/lease_payment_logs/download': downBillApi,
  // 上传账单
  'POST/lease_payment_logs/upload': upBillApi,
  // 导出员工租赁成本
  'POST/house_lease_costs/export': downloadApi,
  // 导出租赁
  'POST/house_leases/export': exportLeaseApi,
  // 审批
  'GET/house_leases/approve': approveApi,
  // 删除租赁合同
  'DELETE/house_lease_contracts/{id}': delContractApi,
  // 获取办公室人员列表
  'POST/house_lease_costs/lease_cost': houseUserApi,
  // 房屋物管租赁分摊
  'POST/house_lease_costs/allocation': shareCostApi,
  // 作废租赁合同
  'PATCH/house_lease_contracts/invalid': invalidApi,
} = Api

let userOptions = ref([])
let {currencyOption} = PaymentModuleUtils

onBeforeMount(() => {
  userListApi().then((rep: any) => {
    userOptions.value = rep.map((_user: any) =>{
      _user.label = _user.alias + '(' + _user.realName+ ')'
      return _user
    })
  })
  
})

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange, 
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const leaseRows = ref<any[]>([])
const handleleaseChange = (rows: object[]) =>{
  leaseRows.value = rows
}

const searchConfig = ref<FromConfig[]>([
  {
    label: '租赁编号',
    value: '',
    upKey: 'leaseId',
    props: { type: 'number'}
  },
  {
    label: '承租人',
    value: '',
    upKey: 'lessee',
  },
  {
    label: '所在地',
    value: '',
    upKey: 'city',
  },
  {
    label: '付款申请责任人',
    value: '',
    upKey: 'leaderName',
  },
  {
    type: 'SELECT',
    label: '租房类型',
    value: '',
    upKey: 'purpose',
    options: [ 
      {label: '办公', id: '办公'},
      {label: '宿舍', id: '宿舍'} 
    ],
    props: {clearable: true, placeholder: '请选择租房类型',},
    seleProps: { }
  },
  {
    type: "TIME",
    label: "合同起",
    value: '',
    upKey: 'fromDate',
    // upProps: { startKey: 'fromDataStart', endKey: 'fromDataEnd', },
    props: {
      // type: 'daterange',
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "合同至",
    value: '',
    upKey: 'toDate',
    // upProps: { startKey: 'toDateStart', endKey: 'toDateEnd', },
    props: {
      // type: 'daterange',
      clearable: true,
    }
  },
  {
    type: 'SELECT',
    label: '合同状态',
    value: '',
    upKey: 'status',
    options: [
      { label: '有效', id: 'Valid' },
      { label: '无效', id: 'Invalid' }
    ],
    props: {clearable: true, placeholder: '请选择合同状态',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '付款周期',
    value: '',
    upKey: 'paymentPeriod',
    options: [
      { label: '月付', id: 'Monthly' },
      { label: '季付', id: 'Quarterly' },
      { label: '半年付', id: 'SemiAnnual' },
      { label: '年付', id: 'Annual' },
    ],
    props: {clearable: true, placeholder: '请选择付款周期',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '审批状态',
    value: '',
    upKey: 'approvedStatus',
    options: [
      { label: '已审批', id: 'APPROVE_SUCCESS' },
      { label: '待审批', id: 'APPROVE_WAIT' },

    ],
    props: {clearable: true, placeholder: '请选择审批状态',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
])

let totalObj: any = reactive({})
const searchHandle = async (params: any) => {
  let _params = {
    ...params,
    createdAt: {
      from: params.createdStart || '',
      to: params.createdEnd || '',
    }
  }

  delete _params.createdAtRange

  delete _params.fromDataStart
  delete _params.fromDataEnd
  delete _params.toDateStart
  delete _params.toDateEnd
  delete _params.createdStart
  delete _params.createdEnd

  let rep = await fetchData(_params, {}, 1)
  Object.assign(totalObj, rep.total)
}

// 删除
const deleteHandle = async (row: any) => {
  await ElMessageBox.confirm(
    `确定删除: ${row.alias}?`,
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  try {
    await delLeaseApi({id: row.id})
    ElMessage.success('删除成功')
    searchHandle(MI_params)

  } catch (error) {
  }

}

// 上传合同
const contractFromEle: any = ref(null)
let contractFileUpId = ref('')
const addContractFg = ref<boolean>(false)
const upload = ref()
const contractFrom = reactive({
  contractNo: '',
  fromDate: '',
  toDate: '',
})
const contractFromRules = reactive({
  contractNo: [{ required: true, message: '请输入租赁合同编号', trigger: 'change' }]
})

const handleExceed = (files: any) => {
    upload.value.clearFiles()
    upload.value.handleStart(files[0])
}
let fileList = []
const onContractChange = (file: any, files: any) => {
  fileList = files
}

const submitFileFg = ref<boolean>(false)
const submitUpload = () => {
  if(fileList.length === 0) {
      // 如果没有选择文件
      ElMessage.warning({message: '请选择文件', grouping: true})
      return
    }
  contractFromEle.value.validate((valid: any, fields: any) => {
    if (valid) {
      upload.value.submit()
    }
  })
}


const customUpFetch = (file: any) => {
    
    submitFileFg.value = true
    upContractApi(
      {
        file: file.file, 
        fromDate: contractFrom.fromDate || '',
        toDate: contractFrom.toDate || '',
        contractNo: contractFrom.contractNo, 
        id: contractFileUpId.value 
      },  
      {
        contentType: "formData"
      }
    )
      .then((rep: any) => {
        submitFileFg.value = false

        addContractFg.value = false
        ElMessageBox.alert(rep.message || '上传成功', '提示', {
          confirmButtonText: '确定',
        })
        upload.value.clearFiles()
        contractFromEle.value.resetFields()
        searchHandle(MI_params)
        detailsFg.value = false
      })
      .catch(() => {
        submitFileFg.value = false
      })
}

const rowUpContract = (row: any) => {
  contractFileUpId.value = row.id
  setTimeout(() => {
    addContractFg.value = true
  })
}

const closeAddContractHandle = () => {
  upload.value.clearFiles()
  contractFromEle.value.resetFields()
}

// 添加租赁合同
const addFg = ref<boolean>(false)
const addConfig = ref<FromConfig[]>([
  cpyCfig({
    label: "承租人",
    upKey: "lessee",
    props: { placeholder: '请选择承租人', clearable: true},
    rule: [{ required: true, message: '请选择承租人', trigger: 'change' }],
    seleProps: { label: "name", valueName: "name"},
  }),
  {
    label: '出租人',
    value: '',
    upKey: 'lessor',
    rule: [{ required: true, message: '必选项', trigger: 'change' }],
  },
  {
    label: '租赁地址',
    value: '',
    upKey: 'address',
  },
  {
    label: '工位数',
    value: undefined,
    upKey: 'seatQuantity',
    props: { precision: 0},
    rule: [{ required: true, message: '必选项', trigger: 'change' }],
  },
  {
    label: '所在地',
    value: '',
    upKey: 'city',
  },
  {
    label: '简称',
    value: '',
    upKey: 'alias',
    rule: [{ required: true, message: '必选项', trigger: 'change' }],
  },
  {
    type: 'SELECT',
    label: '租房类型',
    value: '',
    upKey: 'purpose',
    options: [
      { label: '办公', id: '办公' },
      { label: '宿舍', id: '宿舍' }
    ],
    props: {clearable: true, placeholder: '请选择租房类型',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  userCfig({
    label: '付款责任申请人',
    upKey: 'leaderId',
    rule: [{ required: true, message: '请选择付款责任申请人', trigger: 'change' }],
    props: { disabled: false },
    options: userOptions
  }),
  {
    label: '租赁面积',
    value: '',
    upKey: 'leaseArea',
    props: { type: 'number'},
    rule: [
      // { required: true, message: '请输入租赁面积', trigger: 'change' },
      {
        validator: (rule: any, value: any, callback: any) => {
          if(!value){
            callback()
            return
          }
          if(value.toString().includes('.') && value.toString().split('.')[1].length > 2){
            callback(new Error('只保留小数点后两位'))
          }
          callback()
        },
        trigger: 'change'
      }
    ]
  },
  {
    label: '月物管费',
    value: '',
    upKey: 'pmFee',
    props: { type: 'number'},
    rule: [
    { required: true, message: '请输入月物管费', trigger: 'change' },
      {
        validator: (rule: any, value: any, callback: any) => {
          if(!value){
            callback()
            return
          }

          if(value.toString().includes('.') && value.toString().split('.')[1].length > 2){
            callback(new Error('只保留小数点后两位'))
          }
          callback()
        },
        trigger: 'change'
      }
    ]
  },
  {
    label: '押金',
    value: '',
    upKey: 'deposit',
    props: { type: 'number'},
    rule: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if(!value){
            callback()
            return
          }
          if(value.toString().includes('.') && value.toString().split('.')[1].length > 2){
            callback(new Error('只保留小数点后两位'))
          }
          callback()
        },
        trigger: 'change'
      }
    ]
  },
  {
    label: '月租金',
    value: '',
    upKey: 'monthlyRent',
    props: { type: 'number'},
    rule: [
      { required: true, message: '必选项', trigger: 'change' },
      {
        validator: (rule: any, value: any, callback: any) => {
          if(!value){
            callback()
            return
          }
          
          if(value.toString().includes('.') && value.toString().split('.')[1].length > 2){
            callback(new Error('只保留小数点后两位'))
          }
          callback()
        },
        trigger: 'change'
      }
    ],
  },
  {
    type: 'SELECT',
    label: '付款周期',
    value: '',
    upKey: 'paymentPeriod',
    options: [
      { label: '月付', id: 'Monthly' },
      { label: '季付', id: 'Quarterly' },
      { label: '半年付', id: 'SemiAnnual' },
      { label: '年付', id: 'Annual' },
    ],
    props: {clearable: true, placeholder: '请选择付款周期',},
    seleProps: { label: 'label', valueName: 'id' },
    rule: [{ required: true, message: '必选项', trigger: 'change' }],
  },
  {
    type: 'SELECT',
    label: '交易类型',
    value: '',
    upKey: 'transactionType',
    options: [
      { label: '关联交易', id: 'Related' },
      { label: '非关联交易', id: 'Unrelated' },
    ],
    props: {clearable: false, placeholder: '请选择交易类型',},
    seleProps: { label: 'label', valueName: 'id' },
    rule: [{ required: true, message: '请选择交易类型', trigger: 'change' }],
  },
  {
    type: "TIME",
    label: "首付款日期",
    value: '',
    upKey: 'firstPaymentDate',
    rule: [{ required: true, message: '必选项', trigger: 'change' }],
  },
  {
    type: 'SELECT',
    label: '币种',
    value: '',
    upKey: 'currency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择币种',},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'NUMBER',
    label: '其他费用合计',
    value: undefined,
    upKey: 'estimatedOtherFee',
  },
  {
    type: 'SELECT',
    label: '产权',
    value: '',
    upKey: 'ownership',
    options: [
      { label: '自有物权', id: 'Owner' },
      { label: '他有物权', id: 'Hire' }
    ],
    rule: [{ required: true, message: '请选择产权', trigger: 'change' }],
    props: {clearable: true, placeholder: '请选择产权',},
    seleProps: {label: 'label', valueName: 'id',}
  },
])
const showAddHandle = () =>{
  addConfig.value[7].props = { disabled: false}
  MI_modifyForm({}, addConfig, addFg)
}

const addHandle = async(params: any) => {
  let rep = await createdLeaseApi({...params, contractNo: ''})
  addFg.value = false
  ElMessage.success('创建成功')
  fetchData(MI_params)
  if(!rep) return
  // 上传合同
  contractFileUpId.value = rep.id
  contractFrom.contractNo = dayjs().format('YYYYMMDD') // 默认合同编号（年月日）
  addContractFg.value = true
}


// 房租物管分摊
const shareFg = ref<boolean>(false)
const shareConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'date',
    props: {
      type: 'month',
      clearable: false,
      'value-format': "YYYY-MM-DD"
    },
    rule: [
      { required: true, message: '必选项', trigger: 'change' },
    ]
  },
])
const shareCostHandle = () => {
  MI_modifyForm({}, shareConfig, shareFg, async (params: object) => {
    await shareCostApi(params)
    ElMessage.success('成功')
    shareFg.value = false
  })
}

// 审批
const approvalHandle = async() => {
  if(leaseRows.value.length != 1){
    ElMessage.warning('请只选择一条租赁数据')
    return
  }
  if(leaseRows.value[0].approvedStatus !== 'APPROVE_WAIT') {
    // 如果已审批，（取消审批）
    await ElMessageBox.confirm(
      '确定取消审批?',
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    )
  }
  MI_identify.value = true
  try {
    await approveApi({id: leaseRows.value[0].id})
    MI_identify.value = false
    ElMessage.success('成功')
    searchHandle(MI_params)
  } catch (error) {
    MI_identify.value = false
  }

  
}


// 编辑
const editFg = ref<boolean>(false)
let editRow: any = {}
const showEditHandle = (row: any) => {
  editRow = row
  addConfig.value[7].props = { disabled: true}
  MI_modifyForm(row, addConfig, editFg, async (params: object) => {
    await editLeaseApi({...params, id: editRow.id})
    ElMessage.success('编辑成功')
    editFg.value = false
    searchHandle(MI_params)
  })
  
}
/* const editHandle = async (params: any) => {
  
  try {
    await editLeaseApi({...params, id: editRow.id})
    ElMessage.success('修改成功')
    editFg.value = false
    searchHandle(MI_params)
  } catch (error) {
    console.log(error);
    editFg.value = false
  }
} */

// 租赁合同详情
const detailsFg = ref<boolean>(false)
let contractList = ref([])
let contractRow: {id?: number} = {}
const contractDetailsHandle = (row: any) => {
  contractRow = row
  contractFileUpId.value = row.id
  // 获取合同号列表
  MI_identify.value = true
  getLease_contractApi({id: row.id}).then((rep: any) => {
    contractList.value = rep
    detailsFg.value = true
  }).finally(() => {
    MI_identify.value = false
  })

}
// 下载租赁合同
const downloadContract =  (row: any) => {

  downContractApi({fileId: row.fileId}).then(url => {
    const elt = document.createElement('a')
    elt.setAttribute('href', url)
    elt.setAttribute('download', row.filename)
    elt.style.display = 'none'
    document.body.appendChild(elt)
    elt.click()
    document.body.removeChild(elt)
  })

}
// 删除租赁合同
const contractLoading = ref<boolean>(false)
const delContract = async (row: any) => {
  try {
      await ElMessageBox.confirm(
      `确定删除：${row.filename}?`,
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    )
    contractLoading.value = true
    await delContractApi({ id: row.id })
    ElMessage.success('删除成功')
    contractList.value = await getLease_contractApi({id: contractRow.id})
  } catch (error) {
    contractLoading.value = false
    console.log(error)
  }
}

// 线下交易记录
const billFg = ref<boolean>(false)
let billRow: any = ref('')
const { 
  MI_tableData: billData,
  fetchData: fetchBillData,
  page: BillPage, size: BillSize,
  MI_total: BillTotal, 
  MI_pageChange: BillPageChange, 
  MI_sizeChange: BillSizeChange,
} = new tbMix(getPaymentsApi)

const billDetailsHandle = async (row: any) => {
  
  billRow.value = toRaw(row)
  await fetchBillData({id: row.id})
  billFg.value = true
}
const downloadBill = (row: any) => {
  downBillApi({filename: row.filename, fileId: row.fileId}).then(url => {
    const elt = document.createElement('a')
    elt.setAttribute('href', url)
    elt.setAttribute('download', row.filename)
    elt.style.display = 'none'
    document.body.appendChild(elt)
    elt.click()
    document.body.removeChild(elt)
  })
}

// 展示办公室人数
const { 
  MI_tableData: whData, fetchData: whFetch, page: whPage, size: whSize, 
  MI_total: whTotal, MI_pageChange: whPageChange,
  MI_sizeChange: whSizeChange, MI_identify: whFg, MI_params: whParams
} = new tbMix(houseUserApi)
const officeConfig= ref([
  {
    label: '姓名',
    value: '',
    upKey: 'key',
  },
  {
    type: 'SELECT',
    label: '费用类型',
    value: '',
    upKey: 'feeType',
    options: [
      {
        label: '房租',
        id: 'Rent'
      },
      {
        label: '水电费',
        id: 'Utilities'
      },
      {
        label: '物业管理费',
        id: 'PM'
      },
      {
        label: '其他',
        id: 'Other'
      },
    ],
    props: { clearable: true, placeholder: '请选择费用类型' },
    seleProps: {}
  },
  {
    type: "TIME",
    label: "日期",
    value: dayjs().subtract(1,'months').format('YYYY-MM') + '-01',
    upKey: 'date',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD'
    }
  },
])
const whiteCollarFg = ref<boolean>(false)
let whiteCollarCount = ref<number>(0)
let whiteCollarAddr: any = {}
const whiteCollarHandle = async (row: any) => {
  whiteCollarAddr = row
  officeConfig.value[2].value =  dayjs().subtract(1,'months').format('YYYY-MM') + '-01'
  searchWhiteCollar({leaseId: row.id })
}
const searchWhiteCollar = async (params: object) => {
  MI_identify.value = true
  try {
    let rep = await whFetch({...params, leaseId: whiteCollarAddr.id})
    whiteCollarCount.value = rep.peopleQuantity
    
    MI_identify.value = false
    whiteCollarFg.value = true
  } catch (error) {
    console.log(error);
    
    MI_identify.value = false
  }
}
let whiteCollarExportParams = computed(() =>{
  return {
    date: officeConfig.value[2].value,
    leaseId: whiteCollarAddr.id
  }
})


// 作废租赁合同
const abandonHandle = (row: any) => {
  ElMessageBox.confirm(`确定作废：${row.filename}?`, '提示', {
    type: 'warning',
  }).then(() => {
    contractLoading.value = true
    return invalidApi({contractId: row.id })
  }).then(() => {
    return getLease_contractApi({id: contractRow.id})
  }).then((rep) => {
    ElMessage.success('作废成功')
    contractList.value = rep
  }).finally(() => {
    contractLoading.value = false
  })
}


//---- 表格处理 -----

const paymentPeriodMap = {
  Monthly: '月付',
  Quarterly: '季付',
  SemiAnnual: '半年付',
  Annual: '年付',
}

const formatFeeType = (row: object, column: any, cellValue: string, index: number) =>{
  switch (cellValue) {
    case 'Rent':
      return '房租'
      break;
    case 'Utilities':
      return '水电费'
      break;
    case 'PM':
      return '物业管理费'
      break;
    case 'Other':
      return '其他'
      break;
  
    default:
      break;
  }
}
const formatApprovedStatus = (row: object, column: any, cellValue: string, index: number) =>{
  switch (cellValue) {
    case 'APPROVE_SUCCESS':
      return '已审批'
      break;
    case 'APPROVE_WAIT':
      return '待审批'
      break;
  
    default:
      break;
  }
}

// total 统计
const generateSummary = (param: any) => {
  const { columns, data } = param
  const sums: string[] = ['', '合计']
  columns.forEach((column: any, index: number) => {    
    const value = totalObj[column.property + 'Total']
    if(!(value && typeof value === 'number')) return;
    sums[index] = getNumber(value)
  })
  return sums
}
watch(MI_tableData, (newData) => {
  showTbTotal.value = false
  setTimeout(() => {
    showTbTotal.value = true
  })
})

const showTbTotal = ref<boolean>(false)
watch(MI_tableData, (newData) => {
  showTbTotal.value = false
  setTimeout(() => {
    showTbTotal.value = true
  })
})

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "租赁列表" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
            initSearch: true,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      class: "mb-10 mt-10",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddHandle())),
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    })), [
      [_directive_permission, 'Create']
    ]),
    _createVNode(_component_el_button, {
      type: "info",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'leaseBill' })))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (shareCostHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (approvalHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives(_createVNode(eptBtn, {
      exportFn: _unref(exportLeaseApi),
      exportText: '导出租赁',
      exportParam: {}
    }, null, 8, ["exportFn"]), [
      [_directive_permission, 'Export']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      "show-summary": showTbTotal.value,
      "summary-method": generateSummary,
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px',
      onSelectionChange: handleleaseChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "50",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "租赁编号",
          prop: "id",
          width: "90",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "审批状态",
          prop: "approvedStatus",
          width: "90",
          formatter: formatApprovedStatus
        }),
        _createVNode(_component_el_table_column, {
          label: "租赁地址",
          prop: "address",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "承租人",
          prop: "lessee",
          width: "160",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "出租人",
          prop: "lessor",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "交易类型",
          prop: "transactionType",
          "show-overflow-tooltip": "",
          width: "110",
          formatter: (row) => row.transactionType === 'Related' ? '关联交易': '非关联交易'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "所在地",
          prop: "city",
          width: "130",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "简称",
          prop: "alias",
          width: "130",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "下次付款日期",
          prop: "nextPaymentDate",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "租房类型",
          prop: "purpose",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          label: "产权",
          prop: "ownership",
          width: "110",
          formatter: (row) => row.ownership === 'Owner' ? '自有物权': '他有物权'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "工位数(个)",
          prop: "seatQuantity",
          width: "100",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          label: "办公人数(人)",
          prop: "peopleQuantity",
          width: "110",
          align: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("p", {
              class: "pointer",
              onClick: ($event: any) => (whiteCollarHandle(row))
            }, _toDisplayString(row.peopleQuantity), 9, _hoisted_5)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "付款申请责任人",
          prop: "leaderName",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          label: "合同起",
          prop: "fromDate",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "合同至",
          prop: "toDate",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "合同状态",
          prop: "status",
          width: "190"
        }, {
          default: _withCtx(( { row }) => [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createVNode(_component_el_link, {
                onClick: ($event: any) => (contractDetailsHandle(row))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"]), [
                [_vShow, row.contractId]
              ]),
              _withDirectives(_createVNode(_component_el_link, {
                type: "info",
                onClick: ($event: any) => (rowUpContract(row))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"]), [
                [_vShow, !row.contractId]
              ]),
              _withDirectives(_createVNode(_component_el_tag, {
                class: "ml-10",
                type: row.status === 'Valid' ? '' : 'danger'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.status === 'Valid' ? '有效' : row.status === 'Unenforced' ? '待生效' : '无效'), 1)
                ]),
                _: 2
              }, 1032, ["type"]), [
                [_vShow, row.status]
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "面积(㎡)",
          prop: "leaseArea",
          width: "110",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "月物管费",
          width: "120",
          prop: "pmFee",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "押金",
          width: "120",
          prop: "deposit",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "月租金",
          width: "120",
          prop: "monthlyRent",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "其他费用",
          width: "120",
          prop: "estimatedOtherFee",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency"
        }),
        _createVNode(_component_el_table_column, {
          label: "付款周期",
          prop: "paymentPeriod",
          width: "100"
        }, {
          default: _withCtx(( { row }) => [
            _createTextVNode(_toDisplayString(paymentPeriodMap[row.paymentPeriod as keyof typeof paymentPeriodMap]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "首付款日期",
          prop: "firstPaymentDate",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "最后付款日期",
          prop: "lastPaymentDate",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_dropdown, { trigger: "click" }, {
              dropdown: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      onClick: ($event: any) => (showEditHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Write'],
                      [_vShow, row.approvedStatus === 'APPROVE_WAIT']
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      onClick: ($event: any) => (_ctx.$router.push({ name: 'leasePrincipal', params: row }))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, void 0, "house_lease_leader"]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      disabled: row.approvedStatus === 'APPROVE_WAIT',
                      type: "primary",
                      onClick: ($event: any) => (_ctx.$router.push({ name: 'leaseDetails', params: row }))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])), [
                      [_directive_permission, 'Write']
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      onClick: ($event: any) => (deleteHandle(row)),
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Delete'],
                      [_vShow, row.approvedStatus === 'APPROVE_WAIT']
                    ])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_down)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show-summary", "data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      class: "mt-10",
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      "page-sizes": [10, 30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "编辑合同",
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editFg).value = $event))
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加租赁合同",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '下一步'
        }, { onSearchFn: addHandle }), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "上传合同",
      width: "700px",
      modelValue: addContractFg.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addContractFg).value = $event)),
      onClose: _cache[12] || (_cache[12] = ($event: any) => (closeAddContractHandle()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "contractFromEle",
          ref: contractFromEle,
          model: _unref(contractFrom),
          rules: _unref(contractFromRules),
          inline: true,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "合同起:",
              prop: "fromDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(contractFrom).fromDate,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(contractFrom).fromDate) = $event)),
                  type: "date",
                  placeholder: "合同起",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "合同至:",
              prop: "toDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(contractFrom).toDate,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(contractFrom).toDate) = $event)),
                  type: "date",
                  placeholder: "合同至",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "合同编号:",
              prop: "contractNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(contractFrom).contractNo,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(contractFrom).contractNo) = $event)),
                  placeholder: "请输入合同编号",
                  class: "form-input",
                  clearable: "",
                  maxlength: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(_component_el_divider, { "content-position": "left" }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }),
        _createVNode(_component_el_upload, {
          ref_key: "upload",
          ref: upload,
          action: "",
          limit: 1,
          "auto-upload": false,
          "on-exceed": handleExceed,
          "on-change": onContractChange,
          "http-request": customUpFetch
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submitUpload,
              disabled: submitFileFg.value,
              class: "ml-10"
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "合同详情",
      modelValue: detailsFg.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((detailsFg).value = $event)),
      width: "1100px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (addContractFg.value = true)),
          class: "mb-10",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }),
        (detailsFg.value)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _unref(contractList),
              border: "",
              "max-height": "500"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "编号",
                  prop: "contractNo"
                }),
                _createVNode(_component_el_table_column, {
                  label: "文件名",
                  prop: "filename",
                  width: "200",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "合同起",
                  prop: "fromDate",
                  width: "110"
                }),
                _createVNode(_component_el_table_column, {
                  label: "合同至",
                  prop: "toDate",
                  width: "110"
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "status"
                }),
                _createVNode(_component_el_table_column, {
                  label: "上传日期",
                  prop: "uploadAt",
                  formatter: _unref(formatTime),
                  width: "150"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (downloadContract(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (row.status !== 'ManualInvalid' && (!!row.fromDate || !!row.toDate))
                          ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                              key: 0,
                              onClick: ($event: any) => (abandonHandle(row)),
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_26
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_permission, 'Delete']
                            ])
                          : _createCommentVNode("", true),
                        _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          onClick: ($event: any) => (delContract(row)),
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_27
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Delete']
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, contractLoading.value]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "账单详情",
      modelValue: billFg.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((billFg).value = $event)),
      width: "70%"
    }, {
      default: _withCtx(() => [
        (billFg.value)
          ? _withDirectives((_openBlock(), _createBlock(_component_TheUpBtn, {
              key: 0,
              upText: '上传账单',
              upFetch: _unref(upBillApi),
              upParams: {contractNo: _unref(billRow).contractNo, id: _unref(billRow).id},
              showBtn: true,
              onUpSuccess: _cache[15] || (_cache[15] = ($event: any) => (billDetailsHandle(_unref(billRow))))
            }, null, 8, ["upFetch", "upParams"])), [
              [_directive_permission, 'Create']
            ])
          : _createCommentVNode("", true),
        (billFg.value)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 1,
              data: _unref(billData),
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "编号",
                  prop: "contractNo"
                }),
                _createVNode(_component_el_table_column, {
                  label: "名称",
                  prop: "filename"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  prop: "amount"
                }),
                _createVNode(_component_el_table_column, {
                  label: "上传日期",
                  prop: "uploadAt"
                }),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_link, {
                      onClick: ($event: any) => (downloadBill(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      top: "30px",
      title: '办公室人员(当前月分摊人数: ' + _unref(whiteCollarCount) + ')',
      width: "65%",
      draggable: "",
      modelValue: whiteCollarFg.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((whiteCollarFg).value = $event))
    }, {
      default: _withCtx(() => [
        (whiteCollarFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref: "officeForm"
            }, {
          initSearch: false,
          title: true,
          searchConfig: officeConfig.value,
        }, { onSearchFn: searchWhiteCollar }), null, 16))
          : _createCommentVNode("", true),
        _createVNode(eptBtn, {
          class: "mt-5 mb-5",
          exportFn: _unref(downloadApi),
          exportText: '导出员工租赁成本',
          fileName: '员工租赁成本',
          exportParam: _unref(whiteCollarExportParams)
        }, null, 8, ["exportFn", "exportParam"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(whData),
          "max-height": "620"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "日期",
              prop: "date"
            }),
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "alias"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("p", null, _toDisplayString(row.alias + '(' + row.realName + ')'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "团队",
              prop: "orgName"
            }),
            _createVNode(_component_el_table_column, {
              label: "办公所在地",
              prop: "area"
            }),
            _createVNode(_component_el_table_column, {
              label: "金额",
              prop: "amount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "类型",
              prop: "feeType",
              formatter: formatFeeType
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(whFg)]
        ]),
        _createVNode(_component_el_pagination, {
          total: _unref(whTotal),
          small: "",
          currentPage: _unref(whPage),
          "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event: any) => (_isRef(whPage) ? (whPage).value = $event : null)),
          "page-size": _unref(whSize),
          "onUpdate:page-size": _cache[18] || (_cache[18] = ($event: any) => (_isRef(whSize) ? (whSize).value = $event : null)),
          class: "mb-5 mt-5",
          "page-sizes": [10, 30, 50, 100, 500],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(whPageChange),
          onSizeChange: _unref(whSizeChange)
        }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "房屋物管租赁分摊",
      modelValue: shareFg.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((shareFg).value = $event))
    }, {
      default: _withCtx(() => [
        (shareFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: shareConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})